// extracted by mini-css-extract-plugin
module.exports = {"awardsWrap":"style_awardsWrap__LVhFj","awards":"style_awards__6ZwLr"};